import { render } from "./ChatClient.vue?vue&type=template&id=cc9407f4"
import script from "./ChatClient.vue?vue&type=script&lang=js"
export * from "./ChatClient.vue?vue&type=script&lang=js"

import "./ChatClient.vue?vue&type=style&index=0&id=cc9407f4&lang=css"

import exportComponent from "C:\\dev\\livechat\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__